/**
 * MarketPlaceSetting / EcommercePlaceSetting API yanıtı projede farklı derinliklerde geliyor.
 * Categorys.jsx ile aynı çözümleme.
 */
export function extractMarketPlaceAccounts(axiosResponse) {
  const layer = axiosResponse?.data?.data;
  if (Array.isArray(layer)) return layer;
  if (Array.isArray(layer?.data)) return layer.data;
  if (Array.isArray(axiosResponse?.data?.data?.data)) {
    return axiosResponse.data.data.data;
  }
  return [];
}

export function extractEcommerceAccounts(axiosResponse) {
  const layer = axiosResponse?.data?.data;
  if (Array.isArray(layer)) return layer;
  if (Array.isArray(layer?.data)) return layer.data;
  if (Array.isArray(axiosResponse?.data?.data?.data)) {
    return axiosResponse.data.data.data;
  }
  return [];
}
